export function fetchAnalyticsConfig(remote) {
	return remote.get('crm/analytics-config');
}

export function saveAnalyticsConfig(remote, config) {
	return remote.put('crm/analytics-config', config);
}

export function deleteAnalyticsConfig(remote) {
	return remote.delete('crm/analytics-config');
}
